export function fallbackRequest(smartAccountClient, request) {
    if (smartAccountClient.account?.entryPoint.version === '0.6') {
        return {
            sender: request.sender ?? '0xempty',
            callData: request.callData ?? '0x',
            callGasLimit: request.callGasLimit ?? 0n,
            verificationGasLimit: request.verificationGasLimit ?? 0n,
            preVerificationGas: request.preVerificationGas ?? 0n,
            maxFeePerGas: request.maxFeePerGas ?? 0n,
            maxPriorityFeePerGas: request.maxPriorityFeePerGas ?? 0n,
            nonce: request.nonce ?? 0n,
            signature: request.signature ?? '0x',
            paymasterAndData: request.paymasterAndData ?? '0x',
            initCode: request.initCode ?? '0x',
        };
    }
    else if (smartAccountClient.account?.entryPoint.version === '0.7') {
        return {
            sender: request.sender ?? '0xempty',
            callData: request.callData ?? '0x',
            callGasLimit: request.callGasLimit ?? 0n,
            verificationGasLimit: request.verificationGasLimit ?? 0n,
            preVerificationGas: request.preVerificationGas ?? 0n,
            maxFeePerGas: request.maxFeePerGas ?? 0n,
            maxPriorityFeePerGas: request.maxPriorityFeePerGas ?? 0n,
            paymaster: request.paymaster ?? '0xempty',
            paymasterData: request.paymasterData ?? '0x',
            paymasterPostOpGasLimit: request.paymasterPostOpGasLimit ?? 0n,
            paymasterVerificationGasLimit: request.paymasterVerificationGasLimit ?? 0n,
            factory: request.factory ?? '0xempty',
            factoryData: request.factoryData ?? '0x',
            nonce: request.nonce ?? 0n,
            signature: request.signature ?? '0x',
        };
    }
    throw new Error('Invalid entry point version');
}
